export default __webpack_public_path__ + "static/media/nucampSite.53aa3e39.PNG";